import PropTypes from 'prop-types'
import React from 'react'
import trimText from 'read-more-react/dist/utils/trimText'
import { Box } from 'components/Layout'
import { MarkdownRenderer } from 'components/MarkdownRenderer'
import { FONT_SIZE } from 'Theme'
import { styledSystemResponsivePropTypes } from 'utils/propTypes'

const DEFAULT_MAXIMUM_TEXT_LENGTH = 30
const MINIMUN_TEXT_LENGTH_DECREASER = 20
const IDEAL_TEXT_LENGTH_DECREASER = 10

export const ReadMoreText = ({
  text,
  maxAllowedLength,
  isExpanded,
  fontSize,
  actionButton,
  MarkdownRendererProps,
  ...props
}) => {
  const [visiblePart, trimmedPart] = trimText(
    text,
    maxAllowedLength - MINIMUN_TEXT_LENGTH_DECREASER,
    maxAllowedLength - IDEAL_TEXT_LENGTH_DECREASER,
    maxAllowedLength
  )
  const isTextLong = trimmedPart !== ''
  const renderedDots = isTextLong ? '...' : ''
  return (
    <Box {...props}>
      <MarkdownRenderer
        fontSize={fontSize}
        markdownSource={isExpanded ? text : `${visiblePart}${renderedDots}`}
        {...MarkdownRendererProps}
      />
      {isTextLong && actionButton()}
    </Box>
  )
}

ReadMoreText.defaultProps = {
  maxAllowedLength: DEFAULT_MAXIMUM_TEXT_LENGTH,
}

ReadMoreText.propTypes = {
  text: PropTypes.string.isRequired,
  maxAllowedLength: PropTypes.number,
  isExpanded: PropTypes.bool.isRequired,
  fontSize: styledSystemResponsivePropTypes(
    PropTypes.oneOf(Object.values(FONT_SIZE))
  ),
  MarkdownRendererProps: PropTypes.object,
  actionButton: PropTypes.func.isRequired,
}
